
import {defineComponent, watch} from "vue";
import {ref} from "@vue/reactivity";

const __default__ = defineComponent({
  name: "select-box",
  props: {
    entityName: {
      type: String,
      required: true,
    },

    optionLabelAttribute: {
      required: true,
      type: String,
    },

    modelValue: {
      required: true,
      type: Array,
      default: () => [],
    },

    options: {
      required: true,
      type: Array,
      default: () => [],
    },

    width: {
      required: false,
      type: String,
      default: () => "100%",
    },

    disabled: {
      required: false,
      type: Boolean,
    },

    label: {
      required: true,
      type: String,
    },

    required: {
      required: false,
      type: Boolean,
    },
  },

  setup(props, { emit }) {
    const isSelectOpened = ref(false);
    const allInputsAreChecked = ref(false);

    const optionID = (id: number): string => {
      return props.entityName + "-" + id;
    };

    const toggleSelect = () => {
      if (props.disabled) {
        return;
      }

      isSelectOpened.value = !isSelectOpened.value;
    };

    const updateModelValueFullArray = (allInputsAreChecked): void => {
      const array = allInputsAreChecked ? [...props.options] : [];
      emit("update:modelValue", array);
    };

    const updateModelValue = (option, input: HTMLInputElement): void => {
      const selectedOptions = [...props.modelValue] as Array<any>;

      if (input.checked) {
        selectedOptions.push(option);
      } else {
        const selectedIDs = selectedOptions.map((option) => option.id);
        const index = selectedIDs.indexOf(option.id);
        if (index !== -1) {
          selectedOptions.splice(index, 1);
        }
      }

      emit("update:modelValue", selectedOptions);
    };

    watch(
      () => props.modelValue,
      () => {
        allInputsAreChecked.value = !!(
          props.modelValue.length === props.options.length &&
          props.options.length
        );
      }
    );

    return {
      allInputsAreChecked,
      isSelectOpened,
      optionID,
      toggleSelect,
      updateModelValue,
      updateModelValueFullArray,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "6e69baf8": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__